import { UserPermission } from 'models/user'

export const permissions: Array<{
  label: string
  value: UserPermission
}> = [
  { label: 'кредитами?', value: 'can_credit' },
  { label: 'кредитами2?', value: 'can_credit_2' },
  { label: 'рассрочками?', value: 'can_installment' },
  { label: 'картами?', value: 'can_cards' },
  { label: 'смартпос?', value: 'can_mpost' },
  { label: 'мбизнес?', value: 'can_mbusiness' },
  { label: 'Мурабаха - Товары в рассрочку?', value: 'can_murabaha' },
  { label: 'Универсальная мурабаха?', value: 'can_uni_murabaha' },
  { label: 'картами Мисламик?', value: 'can_hasan' },
  { label: 'мкасса?', value: 'can_mkassa' },
  { label: 'QR?', value: 'can_mqr' },
  { label: 'Изъятие SmartPos/MPos?', value: 'can_removal_pos' },
  { label: 'Смена РКО счета клиента?', value: 'can_rko' },
  { label: 'Смена тарифа на SmartPos?', value: 'can_chenge_tarif' },
  { label: 'MJunior?', value: 'can_m_junior' },
  { label: 'Нерезиденты?', value: 'can_nonresident_card' },
  { label: 'МБизнес ИП?', value: 'can_open_mbusiness' },
  { label: 'M+, Murabaha?', value: 'can_subscribe_services' },
  { label: 'Картомат?', value: 'can_kartomat' },
  { label: 'идентификацией для картоматов?', value: 'can_kartomat_identification' },
  { label: 'MBonus?', value: 'can_m_bonus' },
  { label: 'MPlusLine?', value: 'can_m_plus_line' },
]
